import {
  Area,
  type Area_Transferable,
  type CoordinateSystem,
  DateTime_fromTransferable,
  DateTime_toTransferable,
  type Duration_Transferable,
  Duration_fromTransferable,
  Duration_toTransferable,
} from "@mm/api.meteomatics.com";
import type { DateTime, Duration } from "luxon";

export type LightningBinaryType = 1 | 2 | -999;
export type LightningBinaryAggregation = "none" | "newest_per_cell";

/**
 * Cache/layer request. `datetime` is the selected window end; the URL builder
 * translates it to Iceberg's start-plus-duration convention.
 */
export type LightningBinaryRequest = {
  area: Area<CoordinateSystem.WGS84>;
  datetime: DateTime;
  timeDuration: Duration;
  width: number;
  height: number;
  observedOnly?: boolean;
  typeFilter?: LightningBinaryType[];
  wireVersion: 3;
  aggregation: LightningBinaryAggregation;
};

export type LightningBinaryRequestTransferable = {
  area: Area_Transferable<CoordinateSystem.WGS84>;
  datetime: string;
  timeDuration: Duration_Transferable;
  width: number;
  height: number;
  observedOnly?: boolean;
  typeFilter?: LightningBinaryType[];
  wireVersion: 3;
  aggregation: LightningBinaryAggregation;
};

export function lightningBinaryRequestToTransferable(
  request: LightningBinaryRequest,
): LightningBinaryRequestTransferable {
  return {
    ...request,
    area: request.area.toTransferable(),
    datetime: DateTime_toTransferable(request.datetime),
    timeDuration: Duration_toTransferable(request.timeDuration),
    typeFilter: request.typeFilter ? [...request.typeFilter] : undefined,
  };
}

export function lightningBinaryRequestFromTransferable(
  request: LightningBinaryRequestTransferable,
): LightningBinaryRequest {
  return {
    ...request,
    area: Area.fromTransferable(request.area),
    datetime: DateTime_fromTransferable(request.datetime),
    timeDuration: Duration_fromTransferable(request.timeDuration),
    typeFilter: request.typeFilter ? [...request.typeFilter] : undefined,
  };
}
